// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-medium":"#5e5e5e","fieldset":"_1tLsqdN","fadeIn":"_2poHNpB","cancel":"_2BG0FhR","button":"_19dt5Rt"};